import React from 'react';
import { Box, Typography } from '@mui/material';

export const pageCardSx = {
  border: '1px solid #DFE5F6',
  borderRadius: '24px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 8px 24px rgba(31, 46, 85, 0.06)',
};

export const formFieldSx = {
  '& .MuiOutlinedInput-root': {
    minHeight: 48,
  },
  '& .MuiOutlinedInput-input': {
    py: 1.5,
  },
  '& .MuiSelect-select': {
    py: 1.5,
  },
};

export const compactFormFieldSx = {
  ...formFieldSx,
  '& .MuiOutlinedInput-root': {
    minHeight: 46,
  },
};

export const helperTextSx = {
  '& .MuiFormHelperText-root': {
    ml: 0,
    mt: 1,
  },
};

export const sectionTitleSx = {
  fontSize: 18,
  lineHeight: '28px',
  letterSpacing: '0px',
  fontWeight: 600,
  color: '#1C1B1F',
  mb: 2,
};

export const placeholderTextSx = {
  color: '#625B71',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.5px',
  fontWeight: 400,
};

export const menuProps = {
  PaperProps: {
    sx: {
      mt: 1,
      maxHeight: 320,
      width: 320,
    },
  },
};

export function createMenuProps(overrides = {}) {
  return {
    ...menuProps,
    PaperProps: {
      ...menuProps.PaperProps,
      ...overrides,
      sx: {
        ...menuProps.PaperProps.sx,
        ...(overrides.sx || {}),
      },
    },
  };
}

export function FieldLabel({ label, required = false }) {
  return (
    <Typography className="form-field-label" sx={{ mb: 1 }}>
      {label} {required && <Box component="span" sx={{ color: '#DA342E' }}>*</Box>}
    </Typography>
  );
}
